let currentVersion = null;

async function checkAppVersion() {
    try {
        const res = await fetch("/version.json", { cache: "no-store" });
        const data = await res.json();

        if (!currentVersion) {
            currentVersion = data.version;
        } else if (currentVersion !== data.version) {
            console.log("🔄 New version available.");

            const shouldReload = window.confirm(
                "A new version of this application is available. Click OK to reload."
            );

            if (shouldReload) {
                hardReload();
            }
        }
    } catch (err) {
        console.error("Version check failed:", err);
    }
}

function hardReload() {
    if ('caches' in window) {
        caches.keys().then(names => {
            names.forEach(name => caches.delete(name));
        });
    }

    // Navigate and bypass cache (no ESLint warning)
    window.location.replace(window.location.href);
}

export function startVersionCheck(interval = 30000) {
    setInterval(checkAppVersion, interval);
    checkAppVersion();
}
